import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  ApexNonAxisChartSeries,
  ApexPlotOptions,
  ApexChart,
  ChartComponent,
  ApexFill,
} from 'ng-apexcharts';

export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  labels: string[];
  plotOptions: ApexPlotOptions;
  fill: ApexFill;
  title: {
    text: string;
    align: 'left' | 'center' | 'right';
    style: {
      fontSize: string;
      fontWeight: string;
      fontFamily: string;
    };
  };
};
export interface RadialBarsDataProps {
  name: string;
  data: number;
  color: string;
}

@Component({
  selector: 'app-radialbars-graph',
  templateUrl: './radialbars-graph.component.html',
  styleUrl: './radialbars-graph.component.scss',
})
export class RadialbarsGraphComponent implements OnInit {
  @ViewChild('chart') chart!: ChartComponent;
  public chartOptions!: Partial<ChartOptions>;

  @Input() chartType: 'pie' | 'line' = 'pie';
  @Input() title: string = 'Title';

  @Input({ required: true }) data!: RadialBarsDataProps[];
  @Input() height: number = 350;
  @Input() dataLabel: string = '';
  @Input() showLabel: boolean = false;
  @Input() labelFomatter: string = '%';

  constructor() {}

  ngOnInit(): void {
    console.log("dataaaa",this.data)
    this.chartOptions = {
      series: this.data.map((chart) => chart.data),
      chart: {
        height: this.height,
        type: this.chartType,
      },
      fill: {
        opacity: 1,
        colors: this.data.map((data) => data.color),
      },
      title: {
        text: this.title,
        align: 'left',
        style: {
          fontSize: '16px',
          fontWeight: 'bold',
          fontFamily: 'Arial, sans-serif',
        },
      },
      plotOptions: {
        radialBar: {
          hollow: {
            margin: 0,
            background: '#fff',
            image: undefined,
            position: 'front',
            dropShadow: {
              enabled: true,
              top: 3,
              left: 0,
              blur: 4,
              opacity: 1.24,
            },
          },
          dataLabels: {
            total: {
              show: this.showLabel,
              label: this.dataLabel,
              fontSize: '29px',
              fontWeight: '800',
            },
          },
        },
      },
      labels: this.data.map((chart) => chart.name),
    };
  }
   ngAfterViewInit() {

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 300);
  }
}
